export default {
  Execution: {
    header: {
      title: 'Execução',
      actions: 'Ações',
    },
    pause_program_modal: {
      pause: 'Pausar',
      resume: 'Retomar',
      pause_title: 'Pause o programa',
      resume_title: 'Retome o programa',
      reason: 'Motivo',
      select_reason: 'Selecione um motivo para pausar',
      drought: 'Estiagem',
      hail: 'Granizo',
      lodging: 'Acamamento',
      frost: 'Geada',
      other: 'Outro',
      other_reason: 'Digite o motivo',
      resume_explanation_title: 'O programa está pausado',
      resume_explanation:
        'Ao retomar o programa, o sistema recalculará as datas de cada aplicação e também poderá haver um impacto na eficiência do seu programa',
      resume_confirmation: 'Tem certeza que deseja retomar o programa?',
      describe_reason: 'Descreva',
    },
  },
}
